"use client";

import { useEffect, useState, type FC, type Ref } from "react";
import { Flex, Stack, useMaybePubSub, useDebug } from "@huub-web/ui";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface SocketTemplateProps {
  id: string;
  templates?: TemplateCollection;
  level?: number;
}

export const SocketTemplate: FC<
  SocketTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ id, templates: defaultTemplates, level = 1, ref }) => {
  const pubSub = useMaybePubSub();
  const { log } = useDebug();

  const [templates, setTemplates] = useState<TemplateCollection | null>(null);

  useEffect(() => {
    if (!pubSub) {
      return;
    }

    const unsubscribe = pubSub.subscribe("socketTemplatesUpdate", (data) => {
      const { templatesID, templates } = data;

      if (templatesID === id) {
        setTemplates(templates);

        log(
          "cyan",
          "SocketTemplate",
          "socketTemplatesUpdate",
          templatesID,
          templates,
        );
      }
    });

    return () => unsubscribe();
  }, [pubSub, id]);

  return (
    <Stack data-id={id} ref={ref} reveal>
      {!templates && defaultTemplates && defaultTemplates.length > 0 && (
        <Flex direction="column">
          <TemplatesParser templates={defaultTemplates} level={level} />
        </Flex>
      )}
      {templates && templates.length > 0 && (
        <Flex direction="column">
          <TemplatesParser templates={templates} level={level} />
        </Flex>
      )}
    </Stack>
  );
};
